export const guilt = [
	{
		_id: 0,
		text: "Welcome to the exercise on guilt",
		createdAt: new Date(),
		replyType: "dialogue",
		user: {
			_id: 2,
			name: "Uprise"
		}
	},
	{
		_id: 1,
		text: "This exercise is easier if you’ve already watched the video about the skill",
		createdAt: new Date(),
		replyType: "dialogue",
		quickReplies: {
			_id: 2,
			_next: 4,
			optionType: "radio",
			replyType: "survey",
			questions: [0, 1, 2, 3, 4, 5, 6],
			recurring: true,
			surveyId: "guilt-v1",
			taskId: "exercise-guilt",
			values: [
				{
					label: "Show me the video that explains Guilt",
					videoURI:
						"https://player.vimeo.com/external/246222303.sd.mp4?s=4bb004453ab8cbedb00a5d26f6939816403990b3&profile_id=165",
					vimeoId: "246222303",
					value: "video",
					taskId: "video-retraining",
					replyType: "dialogue",
					quickReplies: {
						_id: 3,
						_next: 4,
						optionType: "radio",
						replyType: "survey",
						questions: [0, 1, 2, 3, 4, 5, 6],
						recurring: true,
						surveyId: "guilt-v1",
						taskId: "exercise-guilt",
						values: [
							{
								label: "Thanks, i've watched the video",
								value: "start",
								questionIndex: 0
							}
						]
					}
				},
				{
					label: "I’ve already watched it. Let’s get started.",
					value: "start",
					questionIndex: 0
				}
			]
		},
		user: {
			_id: 2,
			name: "Uprise"
		}
	},
	{
		_id: 4,
		_next: 5,
		text: "Thanks for doing the exercise with me. 🏋️",
		createdAt: new Date(),
		replyType: "dialogue",
		user: {
			_id: 2,
			name: "Uprise"
		}
	},
	{
		_id: 5,
		_next: 6,
		text:
			"The goal was to help you feel less guilt by recognising that other people always play a role in every outcome. ",
		createdAt: new Date(),
		replyType: "dialogue",
		user: {
			_id: 2,
			name: "Uprise"
		}
	},
	{
		_id: 6,
		_end: true,
		text: "👋 See you next time, I'll take you back.",
		createdAt: new Date(),
		replyType: "dialogue",
		user: {
			_id: 2,
			name: "Uprise"
		}
	}
]
